import { Box } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
const Note = () => {
  const yearSource = new Date().getFullYear()

  return (
    <Box sx={{ padding: '18px 16px' }}>
      <Box sx={{ mb: '4px', fontSize: '15px' }}>
        The Total Weighted Index Score (AI Vibrancy) is obtained in two steps: evaluating each pillar through weighted
        indicators (with default weights provided, but adjustable) and combining these scores to calculate a country's
        annual vibrancy score, with specific weights for the pillars reflecting their overall importance.{' '}
      </Box>
      <Box sx={{ mb: '20px', fontSize: '15px' }}>
        <sup>*</sup>Missing values are imputed using yearly medians across countries for each indicator to compute
        weighted index scores. Indicators unavailable for a given year across all countries are excluded, and their
        weights are proportionally redistributed among the remaining indicators.{' '}
      </Box>
      <Box sx={{ mb: '4px', fontSize: '15px' }}>
        For detailed formulas and weightings, see the{' '}
        <span style={{ fontStyle: 'italic', borderBottom: '1px solid #3b8ac4', color: '#3b8ac4' }}>
          methodology section
        </span>
      </Box>
      <Box sx={{ fontFamily: 'CircularStdMedium' }}>Source: {yearSource} AI Index</Box>
    </Box>
  )
}

export default Note
